import { render, staticRenderFns } from "./NavigationAccountMenu.vue?vue&type=template&id=1161d22d&"
import script from "./NavigationAccountMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationAccountMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAccountMenu.vue?vue&type=style&index=0&id=1161d22d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports